<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSiteLocale } from '../../composables/useSiteLocale'

defineProps<{ open: boolean }>()
const emit = defineEmits<{ 'update:open': [value: boolean]; product: [] }>()
const { t } = useI18n()
const { currentLocale, toggleLocale } = useSiteLocale()
const route = useRoute()
const isHome = computed(() => route.name === 'home')

const close = () => emit('update:open', false)
const product = (event: MouseEvent) => {
  close()
  if (!isHome.value || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return
  event.preventDefault(); emit('product')
}
</script>

<template>
  <header class="site-nav" :class="{ 'site-nav--home': isHome, 'site-nav--download': route.name === 'download' || route.name === 'download-page' }">
    <RouterLink class="site-brand" to="/" @click="close">
      <img class="site-brand__icon" src="/motexa-ride-icon.png" alt="" aria-hidden="true" />
      <span><strong>MOTEXA</strong><small>RIDE / FIELD NOTES</small></span>
    </RouterLink>
    <button class="site-nav__menu" type="button" :aria-expanded="open" :aria-label="currentLocale === 'zh-CN' ? '菜单' : 'Menu'" @click="emit('update:open', !open)">
      <span></span><span></span>
    </button>
    <nav class="site-nav__links" :class="{ 'site-nav__links--open': open }" aria-label="Primary">
      <RouterLink to="/#product" @click="product">{{ t('nav.product') }}</RouterLink>
      <RouterLink to="/docs" data-site-event="docs_entry" data-site-placement="nav" @click="close">{{ t('nav.docs') }}</RouterLink>
      <RouterLink to="/changelog" @click="close">{{ t('nav.changelog') }}</RouterLink>
      <button class="site-nav__locale" type="button" :aria-label="t('common.language')" @click="toggleLocale">
        <span :class="{ active: currentLocale === 'zh-CN' }">中</span><span>/</span><span :class="{ active: currentLocale === 'en-US' }">EN</span>
      </button>
      <RouterLink class="site-nav__cta" to="/download" data-site-event="download_entry" data-site-placement="nav" @click="close">{{ t('nav.download') }}<span>↗</span></RouterLink>
    </nav>
  </header>
</template>

<style scoped>
@media (max-width: 760px) {
  .site-nav--download .site-nav__links { background: rgba(247,250,255,.97); border-color: rgba(28,91,167,.14); box-shadow: 0 20px 50px rgba(47,91,146,.18); }
}
</style>
